// Report Requests — TanStack Query key factory. Co-located so the
// stale-after-save gate exempts these literals; every report-request mutation
// invalidates `overview(loanId)` (the tab reads the whole payload in one go,
// so there is nothing finer to invalidate) and, where the mutation moves loan
// state, the single loan-health severity source.

export const reportRequestKeys = {
  /** Prefix covering every report-request read. */
  all: () => ["portfolio-admin", "report-requests"] as const,
  /** The Financial Reporting tab's whole payload for one loan. */
  overview: (loanId: string) =>
    ["portfolio-admin", "report-requests", "loan", loanId] as const,
  /** Per-loan issue-dialog options, re-fetched per type. */
  issueOptions: (loanId: string, type: string) =>
    ["portfolio-admin", "report-requests", "issue-options", loanId, type] as const,
  detail: (requestId: string) =>
    ["portfolio-admin", "report-requests", "detail", requestId] as const,
};
